import AuditLog from './AuditLog';

export default AuditLog;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/AuditLog/index.js